// extracted by mini-css-extract-plugin
var _1 = "APoc1";
var _2 = "dGZxs";
var _3 = "tLIEt";
var _4 = "K_Q7X";
var _5 = "SD3tB";
var _6 = "US2jH";
var _7 = "VKQ8n";
var _8 = "OJDtv";
var _9 = "RDGUB";
var _a = "BRlhH";
var _b = "L8o7C";
var _c = "Jmanx";
var _d = "Jwc9x";
var _e = "QPmJo";
var _f = "GfKqJ";
var _10 = "JMoq1";
export { _1 as "compact", _2 as "dropContainer", _3 as "dropHoverTreatment", _4 as "full", _5 as "medium", _6 as "tab", _7 as "tabItemContainer", _8 as "tabListContainer", _9 as "tabListRoot", _a as "tabText", _b as "tabTextSelected_Win32Style", _c as "tabTextUnselected", _d as "tabTextUnselectedHover", _e as "tabTextUnselected_Win32Style", _f as "tabText_Win32Style", _10 as "tab_Win32Style" }
